import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogModule, DialogRef, WindowModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LoggerService } from '../../shared/logger.service';
import { CasiCloseOptions } from '../../common/constants.lib';

@Component({
  selector: 'casi-inactive-alert',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogModule,
    WindowModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './inactive-alert.component.html',
  styleUrl: './inactive-alert.component.scss'
})
export class InactiveAlertComponent extends DialogContentBase implements OnInit {

  constructor(
    public override dialog: DialogRef,
    private logger: LoggerService
  ){
    super(dialog);
  }

  //#region Ng Events

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  //#endregion

  public okClose(): void {
    this.logger.debug(`okClose...`);
    this.dialog.close({ text: CasiCloseOptions.Ok });
  }

  public linkClose(): void {
    this.logger.debug('linkClose');
    this.dialog.close({ text: CasiCloseOptions.Navigate })
  }

}
